// extracted by mini-css-extract-plugin
export default {"slot":"BannerQuery-slot-v8h"};